import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ServerInferRequest } from "@ts-rest/core";
import { depositContract } from "@common/contracts/deposit.contract";
import { useScope } from "@state/scopeContext.lib";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { invalidateCashItemQueries } from "./cashItemQueries";

export const depositsContractClient = getBackendAPIClient(depositContract);

export function useCreateDepositMutation() {
    const { workspaceId } = useScope();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (
            body: ServerInferRequest<
                typeof depositContract.createDeposit
            >["body"],
        ) => {
            if (!workspaceId) {
                throw new Error("Workspace is required");
            }

            const { body: response } =
                await depositsContractClient.createDeposit({
                    params: { workspaceId },
                    body,
                });

            return response;
        },
        onSuccess: async () => {
            await invalidateCashItemQueries({ queryClient, workspaceId });
        },
    });
}
